
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MOZ_Ticketing.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import "../../../moreCore/UI/SearchSelect/SearchSelect";

import RadioGroup from '../../../moreCore/UI/RadioGroup/RadioGroup';
import "../../../moreCore/UI/RadioGroup/RadioGroup";
class MOZ_Ticketing extends compose(_StatefulSection) {
    templateString: any = template;

    paidTicketsMode: MdsLax<InstanceType<typeof RadioGroup>>;
    ticketingMode: MdsLax<InstanceType<typeof RadioGroup>>;

    protected _onChange_TicketingMode() {
        let choise = this.ticketingMode.getValue("value");

        this.hideNode(this.paidTicketsMode, choise != 2);
    }

    protected _onChange_PaidTicketsMode() {

    }

    protected afterSetData() {
        let data = this.currentData as VAM2types.EvBookingBooker;


    }

    protected afterReady() {
        //console.log("Moz-Booker: afterReady");

        if (this.hasFeature("Mozarteum/Ticketing")) {

        }
    }

    protected onDirtyChange(currentState: boolean) {
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    protected _onChanged(key: string, value: any) {
        // wird bei jedem onchanged aufgerufen
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.debug(this.id + " startup, Feature?", this.hasModule("EvBooking/Booker"));

        this.setStartupState("ready");
    }
}

export default mdsWidget(MOZ_Ticketing);